import { Configuration } from "@/types/crm/configuration/configuration";

export const salesforceDefaultConfiguration: Configuration = {}
